import { render, staticRenderFns } from "./ModalDataHistoryManagement.vue?vue&type=template&id=04d055ce&scoped=true"
import script from "./ModalDataHistoryManagement.vue?vue&type=script&lang=js"
export * from "./ModalDataHistoryManagement.vue?vue&type=script&lang=js"
import style0 from "./ModalDataHistoryManagement.vue?vue&type=style&index=0&id=04d055ce&prod&scoped=true&lang=css"
import style1 from "./ModalDataHistoryManagement.vue?vue&type=style&index=1&id=04d055ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d055ce",
  null
  
)

export default component.exports